export const mockStrategyProjects = [
  {
    id: "proj_001",
    name: "Mean Reversion RSI",
    description: "Basic mean reversion strategy using RSI oversold/overbought levels.",
    tags: ["Mean Reversion", "RSI", "Conservative"],
    activeVersion: "ver_1.2",
    lastRun: "2024-01-12T14:30:00Z",
    metrics: {
      winRate: 68.5,
      profitFactor: 2.1,
      totalTrades: 142,
      maxDrawdown: 12.4,
      netProfit: 4500.00,
      pnlPercent: 14.2
    },
    versionsCount: 5,
    branchesCount: 2,
    status: "LIVE",
    symbol: "ETH/USD",
    version: "v2.4.1",
    chartColor: "#0df2f2",
    trend: "UP"
  },
  {
    id: "proj_002",
    name: "Bollinger Breakout",
    description: "Trend following strategy using MACD crossover and EMA filter.",
    tags: ["Trend", "MACD", "Aggressive"],
    activeVersion: "ver_2.0",
    lastRun: "2024-01-10T09:15:00Z",
    metrics: {
      winRate: 45.2,
      profitFactor: 1.8,
      totalTrades: 89,
      maxDrawdown: 18.2,
      netProfit: 12500.00,
      pnlPercent: 4.8
    },
    versionsCount: 8,
    branchesCount: 3,
    status: "PAPER",
    symbol: "BTC/USDT",
    version: "v1.2.0",
    chartColor: "#facc15",
    trend: "UP"
  },
  {
    id: "proj_003",
    name: "Grid Scalper Alpha",
    description: "Scalping strategy for opening gap ups on NIFTY50.",
    tags: ["Scalping", "Gap", "Intraday"],
    activeVersion: "ver_0.9",
    lastRun: "2024-01-12T09:15:00Z",
    metrics: {
      winRate: 72.0,
      profitFactor: 1.5,
      totalTrades: 320,
      maxDrawdown: 5.1,
      netProfit: 2100.00,
      pnlPercent: -12.5
    },
    versionsCount: 12,
    branchesCount: 1,
    status: "STOPPED",
    symbol: "SOL/USDC",
    version: "v0.9.5",
    chartColor: "#ef4444",
    trend: "DOWN"
  },
  {
    id: "proj_004",
    name: "LSTM Prediction Model",
    description: "Deep learning model for price prediction.",
    tags: ["AI", "LSTM", "Experimental"],
    activeVersion: "ver_0.1",
    lastRun: "2024-01-13T10:00:00Z",
    metrics: {
      winRate: 0,
      profitFactor: 0,
      totalTrades: 0,
      maxDrawdown: 0,
      netProfit: 0,
      pnlPercent: 0
    },
    versionsCount: 1,
    branchesCount: 1,
    status: "BACKTEST",
    symbol: "Multi",
    version: "v0.1.0-alpha",
    chartColor: "#3b82f6",
    trend: "FLAT"
  },
  {
    id: "proj_005",
    name: "Forex Arb V3",
    description: "Arbitrage strategy for major forex pairs.",
    tags: ["Arbitrage", "Forex", "Low Risk"],
    activeVersion: "ver_3.0",
    lastRun: "2024-01-12T16:20:00Z",
    metrics: {
      winRate: 88.0,
      profitFactor: 3.2,
      totalTrades: 450,
      maxDrawdown: 1.5,
      netProfit: 8500.00,
      pnlPercent: 8.1
    },
    versionsCount: 15,
    branchesCount: 2,
    status: "LIVE",
    symbol: "EUR/USD",
    version: "v3.0.2",
    chartColor: "#0df2f2",
    trend: "UP"
  }
];

export const mockLineageData = {
  "proj_001": [
    {
      id: "ver_2.0",
      parent_id: "ver_1.2",
      name: "Version 2.0 Redesign",
      tag: "v2.0",
      timestamp: "2024-02-15T10:00:00Z",
      author: "DeeTrade User",
      message: "Major upgrade with multi-stage scaling.",
      metrics: { winRate: 72, profitFactor: 2.3 },
      status: "Active"
    },
    {
      id: "ver_1.2.1",
      parent_id: "ver_1.2",
      name: "Experimental Tight SL",
      tag: "exp",
      timestamp: "2023-12-12T16:45:00Z",
      author: "DeeTrade User",
      message: "Tried 1% SL. Too many false exits.",
      metrics: { winRate: 40, profitFactor: 0.9 },
      status: "Failed"
    },
    {
      id: "ver_1.2",
      parent_id: "ver_1.1",
      name: "Add Stop Loss",
      tag: "v1.2",
      timestamp: "2023-12-10T09:00:00Z",
      author: "DeeTrade User",
      message: "Added 2% fixed Stop Loss.",
      metrics: { winRate: 68.5, profitFactor: 2.1 },
      status: "Tested"
    },
    {
      id: "ver_1.1",
      parent_id: "ver_1.0",
      name: "Tweak RSI Period",
      tag: "v1.1",
      timestamp: "2023-12-05T14:20:00Z",
      author: "DeeTrade User",
      message: "Changed RSI period from 14 to 10 for faster signals.",
      metrics: { winRate: 64, profitFactor: 1.8 },
      status: "Tested"
    },
    {
      id: "ver_1.0",
      parent_id: null,
      name: "Initial Commit",
      tag: "v1.0",
      timestamp: "2023-12-01T10:00:00Z",
      author: "DeeTrade User",
      message: "Initial setup with RSI 14, 70/30 levels.",
      metrics: { winRate: 60, profitFactor: 1.5 },
      status: "Tested"
    }
  ]
};
